import Http from "@/api/http";

export default {
  /* 宿舍 列表 */
  schoolDormitoryPage: params => {
    return Http.POST("/schoolDormitorySet/findByPage", params);
  },
  /* 宿舍 新增/修改 */
  schoolDormitorySave: params => {
    return Http.POST("/schoolDormitorySet/save", params);
  },
  // 删除
  schoolDormitoryDelete: params => {
    return Http.GET("/schoolDormitorySet/delete", params);
  },

  /* 宿舍人员 列表 */
  dormitoryStudentManagePage: params => {
    return Http.POST("/dormitoryStudentManage/findByPage", params);
  },
  /* 宿舍人员 批量添加人员到宿舍 */
  dormitoryStudentManageBacthCheckSync: params => {
    return Http.POST("/dormitoryStudentManage/bacthCheckSync", params);
  },
  /* 宿舍人员 删除 */
  dormitoryStudentManageDelete: params => {
    return Http.GET("/dormitoryStudentManage/delete", params);
  },
};
